import { useMutation } from "@tanstack/react-query";
import { inviteRequest, subscribeMail } from "../api/invite.api";

export const useRequestInvite = () => {
  return useMutation({
    mutationFn: (body) => inviteRequest(body),
  });
};

export const useSubscribeMail = () => {
  return useMutation({
    mutationFn: (body) => subscribeMail(body),
  });
};